module.exports = new Promise(function(resolve) {
    var scope = "insXmlValidatorApp";
    if (typeof window[scope] !== "undefined") return resolve(window[scope]);
    var resolved = false;
    function done(container) {
      if (resolved) return;
      resolved = true;
      resolve(container);
    }
    function unavailable(reason) {
      var error = new Error("[MF] Cannot load " + scope + ": " + reason);
      done({
        get: function() { return Promise.reject(error); },
        init: function() {}
      });
    }
    var timer = setTimeout(function() {
      unavailable("connection timed out");
    }, 3000);
    var script = document.createElement("script");
    var remoteUrl = "__INS_XML_VALIDATOR_REMOTE_URL__";
    try {
      var configuration = JSON.parse(window.localStorage.getItem("configuration") || "{}");
      var configuredBase = configuration["insXmlValidatorRemoteUrl"];
      if (configuredBase) {
        remoteUrl = String(configuredBase).replace(/\/+$/, "") + "/remoteEntry.js";
      } else {
        var parsedRemoteUrl = new URL(remoteUrl, window.location.href);
        if ((parsedRemoteUrl.hostname === "localhost" || parsedRemoteUrl.hostname === "127.0.0.1")
          && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
          parsedRemoteUrl.hostname = window.location.hostname;
        }
        remoteUrl = parsedRemoteUrl.toString();
      }
    } catch (error) {
      console.warn("[MF] Cannot resolve tenant remote insXmlValidatorApp", error);
    }
    
    script.src = remoteUrl;
    script.async = true;
    script.onload = function() {
      clearTimeout(timer);
      if (window[scope]) {
        done(window[scope]);
      } else {
        unavailable("container not found");
      }
    };
    script.onerror = function() {
      clearTimeout(timer);
      unavailable("connection failed");
    };
    document.head.appendChild(script);
  });